const RouteConstants: any = {
  root: '/',
  login: '/login',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  changePassword: '/change-password',
  dashboards: '/dashboards',
  visualizations: '/visualizations',
  users: '/users',
  roles: '/roles',
};

export { RouteConstants };
